import dayjs, { ManipulateType } from "dayjs";

type GetDate = {
  from?: string; // Can accept "today", MM/DD/YYYY, ISO strings, or timestamps
  direction?: "before" | "after";
  duration?: number;
  unit?: ManipulateType;
};

// Unified function to normalize and calculate a date
export const getDate = (config?: GetDate): dayjs.Dayjs | undefined => {
  if (!config) {
    console.warn("No configuration provided for date calculation");
    return undefined;
  }

  const { from = "today", direction, duration = 0, unit } = config;

  if (!unit || !direction || !["before", "after"].includes(direction)) {
    console.warn("Invalid configuration for date calculation");
    return undefined;
  }

  // Interpret "today" as the current date
  let baseDate =
    from.toLowerCase() === "today" ? dayjs() : dayjs(from, "MM/DD/YYYY", true);

  // Fallback to flexible parsing if "today" was not specified and strict parsing fails
  if (!baseDate.isValid() && from.toLowerCase() !== "today") {
    baseDate = dayjs(from); // Flexible parsing (e.g., ISO, timestamp)
  }

  if (!baseDate.isValid()) {
    console.warn(
      `Unable to parse 'from' date. Ensure it is "today" or in a recognizable format (e.g., MM/DD/YYYY, ISO, timestamp). Received: ${from}`
    );
    return undefined;
  }

  const result =
    direction === "before"
      ? baseDate.subtract(duration, unit)
      : baseDate.add(duration, unit);

  return result;
};
